/**
 * Session persistence utilities for Algolia search
 */

import { STORAGE_KEY, SESSION_EXPIRY } from "./constants";
import type { SearchResult, SearchFilters, SearchSession } from "./types";

export function persistSession(
  searchQuery: string,
  searchResults: SearchResult[],
  searchFilters: SearchFilters
): void {
  if (searchQuery.trim() && searchResults.length > 0) {
    const session: SearchSession = {
      query: searchQuery,
      results: searchResults,
      filters: searchFilters,
      timestamp: Date.now(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  }
}

export function loadSession(): SearchSession | null {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (!stored) return null;

  try {
    const session: SearchSession = JSON.parse(stored);
    const isExpired = Date.now() - session.timestamp > SESSION_EXPIRY;
    if (isExpired) {
      clearSession();
      return null;
    }
    return session;
  } catch {
    clearSession();
    return null;
  }
}

export function clearSession(): void {
  localStorage.removeItem(STORAGE_KEY);
}
